// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-overlay[data-v-493d171d]{background:rgba(17,68,54,.768627451)!important;max-width:100%;z-index:999!important;text-align:center!important}option[data-v-493d171d]:hover{box-shadow:inset 0 0 10px 100px #1882a8;background:red!important}.opa-50[data-v-493d171d]{opacity:.5!important;pointer-events:none!important}", ""]);
// Exports
module.exports = exports;
